export default __webpack_public_path__ + "static/media/cryo.25d53744.png";